/**
 * Python Preview Service
 *
 * Handles generation of Python export script previews
 */

import { defaultScriptBuilder } from './DefaultScriptBuilder';

import type {
  PreviewGenerationContext,
  PreviewResult,
  TemplateBasedPreviewService
} from './PreviewService.types';

export class PythonPreviewService implements TemplateBasedPreviewService {
  /**
   * Generate Python preview from template
   */
  generateFromTemplate(template: string, context: PreviewGenerationContext): PreviewResult {
    try {
      if (!template) {
        return {
          content: '',
          error: 'Template not provided'
        };
      }

      const content = defaultScriptBuilder.build({
        template,
        symbols: context.symbols,
        rangeStart: context.rangeStart,
        rangeEnd: context.rangeEnd,
        timezone: context.timezone,
        withMetadata: context.includeMetadata,
        apiKey: context.apiKey
      });

      return { content };
    } catch (error) {
      return {
        content: '',
        error: error instanceof Error ? error.message : 'Failed to generate Python preview'
      };
    }
  }

  /**
   * Generate preview (requires template to be provided separately)
   */
  generatePreview(_context: PreviewGenerationContext): PreviewResult {
    return {
      content: '',
      error: 'Python preview requires a template. Use generateFromTemplate() instead.'
    };
  }
}

// Export singleton instance
export const pythonPreviewService = new PythonPreviewService();
